var map = {
	"./albania.png": 41301,
	"./alemania.png": 63364,
	"./andorra.png": 25562,
	"./argentina.png": 2172,
	"./armenia.png": 6600,
	"./aruba.png": 85375,
	"./australia.png": 10169,
	"./austria.png": 27874,
	"./azerbaijan.png": 43772,
	"./bahamas.png": 43197,
	"./barbados.png": 52093,
	"./belgica.png": 45026,
	"./bolivia.png": 67403,
	"./bosnia-and-herzegovina.png": 95779,
	"./botsuana.png": 39861,
	"./brasil.png": 44888,
	"./bulgaria.png": 7496,
	"./cabo-verde.png": 21444,
	"./camboya.png": 67211,
	"./canada.png": 77737,
	"./cape-verde.png": 21026,
	"./card-paper.png": 17994,
	"./checa.png": 90704,
	"./chile.png": 56669,
	"./china.png": 18380,
	"./chipre.png": 61802,
	"./ciudad-del-vaticano.png": 30404,
	"./colombia.png": 49576,
	"./costa-rica.png": 36743,
	"./croacia.png": 26806,
	"./cuba.png": 8400,
	"./curazao.png": 76456,
	"./czechia.png": 1183,
	"./dinamarca.png": 52576,
	"./ecuador.png": 69252,
	"./egipto.png": 58416,
	"./egypt.png": 88536,
	"./el-salvador.png": 68914,
	"./emirates.png": 73408,
	"./eslovaquia.png": 99406,
	"./eslovenia.png": 7950,
	"./estonia.png": 22928,
	"./fiji.png": 24522,
	"./finlandia.png": 33052,
	"./france.png": 78589,
	"./french-polynesia.png": 58087,
	"./georgia.png": 57337,
	"./germany.png": 67633,
	"./greece.png": 3364,
	"./guatemala.png": 86040,
	"./hong-kong.png": 37883,
	"./hungria.png": 8076,
	"./india.png": 23040,
	"./indonesia.png": 68913,
	"./irlanda.png": 40706,
	"./islandia.png": 62345,
	"./islas-feroe.png": 74245,
	"./italy.png": 89822,
	"./jamaica.png": 79999,
	"./japan.png": 34627,
	"./jordania.png": 40120,
	"./kazajistan.png": 27872,
	"./kenia.png": 64558,
	"./kuwait.png": 20204,
	"./laos.png": 99922,
	"./leather.png": 6952,
	"./letonia.png": 2454,
	"./lituania.png": 53157,
	"./luxemburgo.png": 56804,
	"./macedonia.png": 2795,
	"./madagascar.png": 77433,
	"./malasia.png": 87250,
	"./maldivas.png": 44579,
	"./malta.png": 77434,
	"./marrakech.png": 30277,
	"./mauricio.png": 68788,
	"./mexico.png": 37147,
	"./monaco.png": 45136,
	"./mongolia.png": 19131,
	"./montenegro.png": 77813,
	"./myanmar.png": 37040,
	"./namibia.png": 78274,
	"./nepal.png": 79243,
	"./netherlands.png": 14265,
	"./nicaragua.png": 54314,
	"./norway.png": 9533,
	"./nueva-zelanda.png": 22460,
	"./oman.png": 74060,
	"./panama.png": 62310,
	"./paper.png": 60727,
	"./peru.png": 11730,
	"./philippines.png": 66743,
	"./polonia.png": 44087,
	"./portugal.png": 57636,
	"./puerto-rico.png": 16050,
	"./qatar.png": 5261,
	"./republica-dominicana.png": 10738,
	"./rumania.png": 48841,
	"./rusia.png": 77949,
	"./samoa.png": 60202,
	"./san-marino.png": 1642,
	"./saudi-arabia.png": 35415,
	"./seychelles.png": 78908,
	"./singapur.png": 27783,
	"./south-korea.png": 71034,
	"./spain.png": 45628,
	"./sri-lanka.png": 67603,
	"./sudafrica.png": 85175,
	"./sweden.png": 20145,
	"./switzerland.png": 98776,
	"./taiwan.png": 6427,
	"./tanzania.png": 54174,
	"./thailand.png": 15109,
	"./trinidad-and-tobago.png": 94816,
	"./turkey.png": 61913,
	"./ucrania.png": 34837,
	"./united-kingdom.png": 2831,
	"./united-states.png": 75482,
	"./uruguay.png": 9727,
	"./uzbekistan.png": 38055,
	"./venezuela.png": 6912,
	"./vietnam.png": 41486,
	"./world.png": 25343,
	"./zimbabue.png": 17169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26362;